import { Group, Pill, Text } from '@mantine/core';

import { Nomenclature } from '@feature/nomenclature';

interface WosIndexListProps {
  indexes: Nomenclature[];
}

export function WosIndexList({ indexes }: WosIndexListProps) {
  if (!indexes || indexes.length === 0) {
    return null;
  }

  return (
    <Group>
      <Text>Indexare WoS: </Text>
      {indexes.map(idx => (
        <Pill
          bg="green"
          c="white"
          key={idx.name}
        >
          {idx.name}
        </Pill>
      ))}
    </Group>
  );
}
